<script setup lang="ts">
interface Props {
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
})

const emit = defineEmits<{
  insertMarkdown: [syntax: string]
}>()

const insertH1 = () => emit('insertMarkdown', '# ')
const insertH2 = () => emit('insertMarkdown', '## ')
const insertH3 = () => emit('insertMarkdown', '### ')
const insertBold = () => emit('insertMarkdown', '****')
const insertItalic = () => emit('insertMarkdown', '**')
const insertList = () => emit('insertMarkdown', '• ')
const insertNumbered = () => emit('insertMarkdown', '1. ')
</script>

<template>
  <div class="markdown-toolbar">
    <button
      class="toolbar-btn"
      title="標題 1"
      :disabled="disabled"
      @click="insertH1"
    >
      H1
    </button>
    <button
      class="toolbar-btn"
      title="標題 2"
      :disabled="disabled"
      @click="insertH2"
    >
      H2
    </button>
    <button
      class="toolbar-btn"
      title="標題 3"
      :disabled="disabled"
      @click="insertH3"
    >
      H3
    </button>

    <div class="separator" />

    <button
      class="toolbar-btn"
      title="粗體"
      :disabled="disabled"
      @click="insertBold"
    >
      <strong>B</strong>
    </button>
    <button
      class="toolbar-btn"
      title="斜體"
      :disabled="disabled"
      @click="insertItalic"
    >
      <em>I</em>
    </button>

    <div class="separator" />

    <button
      class="toolbar-btn"
      title="無序列表"
      :disabled="disabled"
      @click="insertList"
    >
      •
    </button>
    <button
      class="toolbar-btn"
      title="有序列表"
      :disabled="disabled"
      @click="insertNumbered"
    >
      1.
    </button>
  </div>
</template>

<style scoped>
.markdown-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  flex-wrap: wrap;
}

.toolbar-btn {
  padding: 4px 8px;
  min-width: 32px;
  height: 28px;
  border: 1px solid #d0d0d0;
  background-color: white;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.toolbar-btn:hover:not(:disabled) {
  background-color: #e8e8e8;
  border-color: #999;
}

.toolbar-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.separator {
  width: 1px;
  height: 20px;
  background-color: #d0d0d0;
}
</style>
